import { h } from 'preact'
import { useMyPublicProfile } from 'lib/membershipAppStateHooks'
import FloatingChatConversation from './FloatingChatConversation'
import './index.sass'

export default function FloatingChatWindow({openChats, closeChatConversation}) {
  const { myPublicProfile } = useMyPublicProfile('FloatingChatWindow')

  return (
    <div className="FloatingChatWindow">
      {/* Open Chat Conversations */}
      {Array.from(openChats.entries()).map(([chatKey, chat]) => (
        <FloatingChatConversation
          key={chatKey}
          chat={chat}
          onClose={() => closeChatConversation(chatKey)}
          myPublicProfile={myPublicProfile}
        />
      ))}
    </div>
  )
}
